"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyParseResponse = exports.applyCheckStatus = void 0;

// 默认状态解析
var applyCheckStatus = function applyCheckStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.response = response;
  return Promise.reject(error);
}; // 默认类型解析


exports.applyCheckStatus = applyCheckStatus;

var applyParseResponse = function applyParseResponse(response) {
  return response.json();
};

exports.applyParseResponse = applyParseResponse;